import { render, staticRenderFns } from "./warehousing.vue?vue&type=template&id=3957c41c&scoped=true&"
import script from "./warehousing.vue?vue&type=script&lang=js&"
export * from "./warehousing.vue?vue&type=script&lang=js&"
import style0 from "./warehousing.vue?vue&type=style&index=0&id=3957c41c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3957c41c",
  null
  
)

export default component.exports